import _ from 'lodash';
import moment from 'moment-timezone';
import Plyr from 'plyr';
import VTooltip from 'v-tooltip';
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueRouter from 'vue-router';
import VueScreen from 'vue-screen';

require('./bootstrap');

window.sha256 = require('js-sha256');
window.Vue = require("vue").default;
window.Bus = new Vue();
window.URI = require('urijs');
window.Cookies = require('js-cookie')

require('./filters');
require('./analytics');
require('./mixins');


Vue.use(VueScreen);
Vue.use(VueRouter);
Vue.use(VueCookies);
Vue.use(VTooltip);

/**
 * Vue components, around the site.
 */
Vue.component('test-component', require('./components/TestComponent.vue').default);

Vue.component('membership-form-component', require('./components/MembershipFormComponent.vue').default);
Vue.component('new-member-enquiry', require('./components/NewMemberEnquiry.vue').default);
Vue.component('member-get-member-component', require('./components/MemberGetMemberComponent.vue').default);
Vue.component('download-form-component', require('./components/DownloadFormComponent.vue').default);
Vue.component('generic-download-component', require('./components/GenericDownloadComponent.vue').default);
Vue.component('generic-contact-enquiry', require('./components/GenericContactEnquiry.vue').default);
Vue.component('apprenticeship-form', require('./components/ApprenticeshipForm.vue').default);
Vue.component('competition-subscribe-component', require('./components/CompetitionSubscribeComponent.vue').default);
Vue.component('treatment-class-availability', require('./components/TreatmentClassAvailability.vue').default);
Vue.component('treatment-availability', require('./components/TreatmentAvailability.vue').default);
Vue.component('class-availability', require('./components/ClassAvailability.vue').default);
Vue.component('treatments-feed', require('./components/TreatmentsFeed.vue').default);

// Vue.component('map-component', require('./components/MapComponent.vue').default);
Vue.component('subscribe-component', require('./components/SubscribeComponent.vue').default);
Vue.component('subscribe-cta', require('./components/SubscribeCta.vue').default);
Vue.component('subscribe-modal', require('./components/SubscribeModal.vue').default);
Vue.component('contact-component', require('./components/ContactComponent.vue').default);
Vue.component('modal-component', require('./components/ModalComponent.vue').default);
Vue.component('gift-cards-feed', require('./components/GiftCardsFeed.vue').default);
Vue.component('drop-hint-component', require('./components/DropHintComponent.vue').default);
Vue.component('collection-component', require('./components/CollectionComponent.vue').default);
Vue.component('marketing-subscribe', require('./components/MarketingSubscribe.vue').default);

Vue.component('new-package-calendar', require('./components/NewPackageCalendar.vue').default);
Vue.component('booking-bar', require('./components/BookingBar.vue').default);

Vue.component('hch-home-feed', require('./components/HchHomeFeed.vue').default);
Vue.component('eden-home-feed', require('./components/EdenHomeFeed.vue').default);

Vue.component('blog-feed', require('./components/BlogFeed.vue').default);
Vue.component('journal-feed', require('./components/JournalFeed.vue').default);
Vue.component('events-feed', require('./components/EventsFeed.vue').default);

Vue.component('pre-arrival-component', require('./components/PreArrivalComponent.vue').default);
Vue.component('pre-arrival-public-component', require('./components/PreArrivalPublicComponent.vue').default);

/**
 * Vue Components (Booking App)
 */
Vue.component('login-modal', require('./book/LoginModal.vue').default);
Vue.component('login-register', require('./book/LoginRegister.vue').default);
Vue.component('register-modal', require('./book/RegisterModal.vue').default);
Vue.component('forgot-password-modal', require('./book/ForgotPasswordModal.vue').default);
Vue.component('logout-component', require('./book/LogoutComponent.vue').default);
Vue.component('dynamic-logo-component', require('./book/DynamicLogoComponent.vue').default);
Vue.component('rate-calendar', require('./book/RateCalendar.vue').default);

const Account = Vue.component('account-component', require('./book/AccountComponent.vue').default);
const PasswordReset = Vue.component('password-reset-component', require('./book/PasswordResetComponent.vue').default);
const RequestPasswordReset = Vue.component('request-password-reset', require('./book/RequestPasswordReset.vue').default);


/**
 * Vue Components (Portal)
 */
const PortalHome = Vue.component('portal-home', require('./membership/PortalHome.vue').default);
Vue.component('portal-login', require('./membership/PortalLoginComponent.vue').default);
Vue.component('portal-logout', require('./membership/PortalLogout.vue').default);
Vue.component('member-account', require('./membership/MemberAccount.vue').default);
Vue.component('book-classes', require('./membership/BookClasses.vue').default);
Vue.component('class-bookings', require('./membership/ClassBookings.vue').default);
Vue.component('member-details', require('./membership/MemberDetails.vue').default);
Vue.component('members-cart', require('./membership/MembersCart.vue').default);
Vue.component('member-benefit-feed', require('./membership/MemberBenefitFeed.vue').default);
Vue.component('member-benefit-carousel', require('./membership/MemberBenefitCarousel.vue').default);
Vue.component('portal-password-reset', require('./membership/PortalPasswordReset.vue').default);

Vue.component('password-checker', require('./membership/PasswordChecker.vue').default);

/**
 * Routes (Booking App)
 */
const routes = [
    {
        name: 'account',
        path: '/book/account',
        component: Account,
        props: true
    },
    {
        name: 'request-password-reset',
        path: '/book/account/request-password-reset',
        component: RequestPasswordReset,
        props: true
    },
    {
        name: 'password-reset',
        path: '/book/account/password-reset',
        sensitive: false,
        component: PasswordReset,
        props: true
    },
    {
        path: '/book/:pathMatch(.*)*',
        beforeEnter(to, from, next) {
            window.location.href = '/404';
        }
    }
    /*{
        name: 'eden-portal-home',
        path: '/eden-hall/members-portal',
        component: PortalHome,
        props: { venue: 'eden-hall' }
    },
    {
        name: 'hch-portal-home',
        path: '/hoar-cross-hall/members-portal',
        component: PortalHome,
        props: { venue: 'hoar-cross-hall' }
    }*/
]

/**
 * Create Router instance (Booking App)
 */
const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes
})

router.afterEach((to, from) => {
    $('html').removeClass('no-scroll');
    // Add class for location to body
    if (to.params.venue) {
        if (to.params.venue == 'hoar-cross-hall') {
            $('body').addClass('hch');
        } else {
            $('body').removeClass('hch');
        }
        if (to.params.venue == 'eden-hall') {
            $('body').addClass('eh');
        } else {
            $('body').removeClass('eh');
        }
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
var heartbeatTimer = null;

const app = new Vue({
    el: '#app',
    router: router,
    /**
     * The application's data.
     */
    data() {
        return {
            system: window.RS,
            cart: {
                FolioBalance: null,
                FolioItems: null,
                Guaranteed: null,
                WebFolioItem: null,
                inclusivesBooked: false
            },
            inclusives: null,
            booking: {
                date: null,
                type: null,
                location: null,
                guests: null,
                nights: null,
                rooms: null
            },
            venue: null,
            updatingCart: null,
            showModal: null,
            fiveMinModal: true,
            inclusiveRates: [],
            inclusiveTreatmentList: [],
            guestnames: JSON.parse(window.localStorage.getItem('guestnames')),
            upsellOnlyRate: 'DSUMDAZE',
        }
    },

    beforeMount() {
        Bus.$on('UpdateCart', () => {
            this.getWebFolio()
        });

        Bus.$on('RefreshSystem', () => {
            this.refreshSystem()
        });

        Bus.$on('RefreshExtras', () => {
            this.refreshExtras()
        });

        Bus.$on('UpdateSession', () => {
            this.updateSession()
        });

        Bus.$on('StartGiftCards', () => {
            this.systemLoad()
            this.getWebFolio()
        });

        Bus.$on('RestartBooking', (redirect) => {
            window.localStorage.removeItem('webfolio_rooms');
            this.clearCart(redirect)
        });

        Bus.$on('RemoveItem', (item) => {
            this.removeBooking(item.FolioId)
        });
    },

    watch: {
        cart: function (newVal, oldVal) {
            if (newVal.FolioItems == 0) {
                Bus.$emit('priceUpdated')
            }
            // Watch inclusives for ready to proceed
            var ic = 0
            var ib = 0
            _.each(newVal.WebFolioItem, function (booking) {
                if (booking.InclusiveTreatments && !booking.HasUpsells) {
                    _.each(booking.InclusiveTreatments.Inclusives, function (inc) {
                        ic++
                        if (inc) {
                            ib++
                        }
                    })
                }
            })
            if (ic > 0) {
                if (ic == ib) {
                    newVal.inclusivesBooked = true
                } else {
                    newVal.inclusivesBooked = false
                }
            } else {
                newVal.inclusivesBooked = true
            }
        },
        $route: function (to, from) {
            if (document.getElementById('awin')) {
                awin.remove()
            }

            if (to.name !== "checkout") {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.defer = 'defer';
                script.id = 'awin'
                script.src = "https://www.dwin1.com/65940.js";
                document.getElementsByTagName('body')[0].appendChild(script);
            }
        }
    },

    mounted() {
        var self = this

        // Get all the Rates that have inclusive treatments

        _.each(self.system.inclusive_rates, function (ir) {
            // Add the rates
            _.each(ir.package_rate_code, function (r) {
                self.inclusiveRates.push(r)
            })
            // Add the inclusives
            if (ir.inclusives) {
                _.each(ir.inclusives, function (r) {
                    if (r != "") {
                        self.inclusiveTreatmentList.push(r)
                    } else {
                        r = null
                    }
                })
            }
            if (ir.second_inclusives) {
                _.each(ir.second_inclusives, function (r) {
                    if (r != "") {
                        self.inclusiveTreatmentList.push(r)
                    } else {
                        r = null
                    }
                })
            }
            if (ir.upsells) {
                _.each(ir.upsells, function (r) {
                    if (r != "") {
                        self.inclusiveTreatmentList.push(r)
                    } else {
                        r = null
                    }
                })
            }
        })

        if (window.location.href.indexOf('book') > -1 || window.location.href.indexOf('portal') > -1) {
            this.systemLoad();

            if (this.system.WebFolioId) {
                this.getWebFolio();
            }
        }

        self.inclusives = _.filter(self.system.treatments, function (t) { return _.includes(self.inclusiveTreatmentList, t.SpaItemId) })

        if (!window.localStorage.getItem('guestnames')) {
            var guestnames = {}
            guestnames[this.system.WebFolioId] = {}
            window.localStorage.setItem('guestnames', JSON.stringify(guestnames))
        } else {
            // Clear down all the old stuff
            var guestnames = JSON.parse(window.localStorage.getItem('guestnames'))

            if (!guestnames[this.system.WebFolioId]) {
                guestnames = {}
                guestnames[this.system.WebFolioId] = {}
                window.localStorage.setItem('guestnames', JSON.stringify(guestnames))
            }
        }

        if (self.upsellOnlyRate) {
            self.inclusiveRates.push(self.upsellOnlyRate)
        }

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.defer = 'defer';
        script.id = 'awin'
        script.src = "https://www.dwin1.com/65940.js";
        document.getElementsByTagName('body')[0].appendChild(script);
    },

    methods: {
        systemLoad() {
            if (this.system.SystemState == 'ONLINE') {

                /* Start the timout countdown */
                // Set a cookie based on the WebFolioTimeout remaining minutes.This is global for all tabs.
                var remaining = this.system.WebFolioRemainingTimeoutMinutes ? this.system.WebFolioRemainingTimeoutMinutes : 19
                var fiveMin = remaining - 5
                $cookies.set("be_sessionid", this.system.SessionId, 60 * remaining)
                $cookies.set("be_fivemin", this.system.SessionId, 60 * fiveMin)
                this.hartbeat()

            } else {
                this.showModal = { titleOne: '<span class="font-italic">Oh no!</span> Our website is<br/>currently so busy, bookings', titleTwo: 'are temporarily unavailable.', message: 'Please call reservations on 01283 576522', btn: 'Retry', btnUrl: null }
            }
        },

        refreshSystem() {
            axios.get('/rs/system')
                .then(response => {
                    this.system = response.data
                    this.systemLoad()
                })
        },

        updateSession() {
            var request = {
                method: 'UpdateSession',
                data: {
                    SessionId: this.system.SessionId,
                    WebFolioId: this.system.WebFolioId,
                    CustomerId: this.system.CustomerId,
                    BookingAgentId: null
                }
            }
            axios.post('/rs/request', request)
                .then(response => {
                    this.refreshSystem()
                });
        },

        hartbeat() {
            if (!window.heartbeatTimer) {
                window.heartbeatTimer = setInterval(this.cleanupWebfolio, 1000)
            }
            if (!window.fiveMinuteTimer) {
                window.fiveMinuteTimer = setInterval(this.fiveMinuteWarning, 1000)
            }
        },

        cleanupWebfolio() {
            if (!$cookies.get('be_sessionid')) {
                // Reset timer
                clearInterval(window.heartbeatTimer)

                console.log('WebFolio expired at: ' + moment().format('YYYY-MM-DD hh:mm'))

                // Set return path (booking/GC/Membership)
                var uri = new URI(window.location.href)

                var path = '/book'
                if (uri.segment(1) == 'members-portal') {
                    path = '/' + uri.segment(0) + '/members-portal'
                }

                // Remove Guests Added flag
                sessionStorage.removeItem("guestsAdded")

                // Show session expired modal
                this.showModal = null
                this.showModal = { titleOne: '<span>Oh no!</span><br> Unfortunately your session', titleTwo: 'has expired', message: 'Please reload the page to start again', btn: 'Reload', btnUrl: path }

                // Clear session
                axios.get('/rs/clearSession')
                    .then(response => {
                        console.log('session cleared...')
                    });
            }
        },

        fiveMinuteWarning() {
            if (!$cookies.get('be_fivemin')) {
                // Reset timer
                clearInterval(window.fiveMinuteTimer)
                if (this.cart.FolioItems) {
                    $('#five-min-modal').modal('show')
                }
            }
        }
    }

});

document.addEventListener('DOMContentLoaded', () => {
    // Note: Hero video optimization is now handled in video-optimization.js
    // Initialize Plyr for hero videos
    const heroVideos = document.querySelectorAll('.section-hero-video video, .section-hero-video-sound video');

    if (heroVideos.length > 0) {
        // Initialize Plyr only after video is loaded
        heroVideos.forEach(video => {
            video.addEventListener('loadedmetadata', function () {
                new Plyr(video, {
                    autoplay: true,
                    muted: true,
                    playsinline: true,
                    loop: { active: true }
                });
            });
        });
    }

    // Handle Instagram videos
    const instagramVideos = document.querySelectorAll('.instagram-video');
    if (instagramVideos.length > 0) {
        instagramVideos.forEach(video => {
            // Add loaded class when video can play
            video.addEventListener('canplay', function () {
                video.classList.add('loaded');
                // Fade out the poster image when video is ready
                const posterElement = video.parentElement.querySelector('.instagram-poster');
                if (posterElement) {
                    posterElement.style.opacity = '0';
                }
            });
        });
    }

    // Initialize Plyr for other videos (excluding Instagram videos which don't need Plyr)
    const otherVideos = document.querySelectorAll('video:not(.section-hero-video video):not(.section-hero-video-sound video):not(.instagram-video)');
    if (otherVideos.length > 0) {
        const players = Plyr.setup(otherVideos, {
            autoplay: true,
            muted: true,
            playsinline: true,
            loop: { active: true }
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const lazyBackgrounds = document.querySelectorAll("[data-bg]");

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                let bgElement = entry.target;
                const bgUrl = bgElement.getAttribute('data-bg');

                if (bgUrl && bgUrl !== 'null' && bgUrl !== 'undefined') {
                    bgElement.style.backgroundImage = `url('${bgUrl}')`;
                }

                // Always remove the data-bg attribute and stop observing
                bgElement.removeAttribute('data-bg');
                observer.unobserve(bgElement);
            }
        });
    });

    lazyBackgrounds.forEach(bg => {
        observer.observe(bg);
    });
});

/**
 * Import scripts
 */
require('./fslightbox');
require('./scripts');
require('./video-optimization');

